module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc9-7d0584082954602581f558050292512c.jpg";